export default [
  {
    path: "/resources",
    name: "ResourceDiscovery",
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/resources";
    }
  }
];
